<div class="flex flex-col h-full">
  <div class="mb-4 flex items-center justify-between">
    <div class="text-sm text-base-content max-w-3xl">
      Manage which rule types exist and the param schemas they accept. The
      underlying operations (the executable Python callables) are listed
      read-only in the modal; admins compose new rule types by binding an
      existing operation to a new label and param set.
    </div>
    <button
      type="button"
      (click)="beginCreate()"
      class="h-9 px-4 border border-base-300 rounded text-sm text-dark font-medium hover:bg-info hover:text-white transition-colors"
    >
      + New Rule Type
    </button>
  </div>

  <div class="flex-1 overflow-y-auto bg-base-100 border border-base-300 rounded-lg">
    <!-- Field-level rule types -->
    <section>
      <div class="px-4 py-3 bg-base-200 border-b border-base-300">
        <h3 class="text-sm font-bold text-primary uppercase tracking-wide">
          Field-level rule types ({{ fieldDefs().length }})
        </h3>
      </div>
      <table class="table w-full text-sm">
        <thead>
          <tr class="h-[44px] bg-base-200">
            <th class="py-2 px-4 text-left font-bold text-primary">Code</th>
            <th class="py-2 px-4 text-left font-bold text-primary">Label</th>
            <th class="py-2 px-4 text-left font-bold text-primary">Operation</th>
            <th class="py-2 px-4 text-left font-bold text-primary">Params</th>
            <th class="py-2 px-4 text-left font-bold text-primary">Active</th>
            <th class="py-2 px-4 font-bold text-primary">Actions</th>
          </tr>
        </thead>
        <tbody *ngIf="fieldDefs().length > 0; else noField">
          <tr
            *ngFor="let d of fieldDefs(); trackBy: trackById"
            class="h-[44px] even:bg-base-200"
          >
            <td class="py-2 px-4 text-primary font-mono text-xs">{{ d.code }}</td>
            <td class="py-2 px-4 text-primary font-medium">{{ d.label }}</td>
            <td class="py-2 px-4 text-primary text-xs font-mono">{{ opLabelFor(d) }}</td>
            <td class="py-2 px-4 text-base-content/70 text-xs">{{ paramSummary(d) }}</td>
            <td class="py-2 px-4">
              <input
                type="checkbox"
                class="toggle toggle-sm"
                [checked]="d.is_active"
                (change)="toggleActive(d)"
                [attr.aria-label]="'Toggle active for ' + d.code"
              />
            </td>
            <td class="py-2 px-4">
              <button
                class="cursor-pointer text-primary-focus hover:text-primary transition-colors"
                (click)="beginEdit(d)"
                aria-label="Edit"
              >
                <fa-icon [icon]="'edit'" class="h-4 w-4"></fa-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <ng-template #noField>
          <tr>
            <td colspan="6" class="py-6 text-center text-sm text-base-content/70">
              No field rule types defined.
            </td>
          </tr>
        </ng-template>
      </table>
    </section>

    <!-- Cross-field rule types -->
    <section>
      <div class="px-4 py-3 bg-base-200 border-b border-t border-base-300">
        <h3 class="text-sm font-bold text-primary uppercase tracking-wide">
          Cross-field rule types ({{ crossDefs().length }})
        </h3>
      </div>
      <table class="table w-full text-sm">
        <thead>
          <tr class="h-[44px] bg-base-200">
            <th class="py-2 px-4 text-left font-bold text-primary">Code</th>
            <th class="py-2 px-4 text-left font-bold text-primary">Label</th>
            <th class="py-2 px-4 text-left font-bold text-primary">Operation</th>
            <th class="py-2 px-4 text-left font-bold text-primary">Params</th>
            <th class="py-2 px-4 text-left font-bold text-primary">Active</th>
            <th class="py-2 px-4 font-bold text-primary">Actions</th>
          </tr>
        </thead>
        <tbody *ngIf="crossDefs().length > 0; else noCross">
          <tr
            *ngFor="let d of crossDefs(); trackBy: trackById"
            class="h-[44px] even:bg-base-200"
          >
            <td class="py-2 px-4 text-primary font-mono text-xs">{{ d.code }}</td>
            <td class="py-2 px-4 text-primary font-medium">{{ d.label }}</td>
            <td class="py-2 px-4 text-primary text-xs font-mono">{{ opLabelFor(d) }}</td>
            <td class="py-2 px-4 text-base-content/70 text-xs">{{ paramSummary(d) }}</td>
            <td class="py-2 px-4">
              <input
                type="checkbox"
                class="toggle toggle-sm"
                [checked]="d.is_active"
                (change)="toggleActive(d)"
                [attr.aria-label]="'Toggle active for ' + d.code"
              />
            </td>
            <td class="py-2 px-4">
              <button
                class="cursor-pointer text-primary-focus hover:text-primary transition-colors"
                (click)="beginEdit(d)"
                aria-label="Edit"
              >
                <fa-icon [icon]="'edit'" class="h-4 w-4"></fa-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <ng-template #noCross>
          <tr>
            <td colspan="6" class="py-6 text-center text-sm text-base-content/70">
              No cross-field rule types defined.
            </td>
          </tr>
        </ng-template>
      </table>
    </section>
  </div>
</div>

<app-rule-type-definition-modal
  [modalId]="modalId"
  [definition]="editingDef()"
  (closed)="onModalClosed()"
  (created)="onModalCreated($event)"
></app-rule-type-definition-modal>
